// extracted by mini-css-extract-plugin
module.exports = {"contactBlock":"contact-formspree-module--contactBlock--2da9M","response":"contact-formspree-module--response--3-ta-"};